import { reviewEventHandlers } from '../../features/review/events/reviewEvents';
import { sourcesEventHandlers } from '../../features/sources/events/sourcesEvents';
import { reviewRecordsEventHandlers } from '../../features/deduplication/events/reviewRecordsEvents';
import type { EventHandlerMap } from './eventHandler';

export const eventHandlerRegistry: EventHandlerMap[] = [
    reviewEventHandlers,
    sourcesEventHandlers,
    reviewRecordsEventHandlers,
];
